'use strict'

import 'alpinejs/dist/alpine-ie11'
import './_polyfills.js'

// import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes'
// import 'focus-visible'

// For the search only version
import algoliasearch from 'algoliasearch/lite';

import conditioner, { idle } from '@parallaxagency/conditioner'

conditioner.addPlugin({
  moduleSetName: name => `./components/${name}.js`,
  moduleGetConstructor: module => module.default,
  moduleImport: name => import(/* webpackChunkName: 'conditioner' */ `${name}`)
})
conditioner.addPlugin(idle)
conditioner.hydrate(document.documentElement)




const searchInput = document.getElementById('search');
if (searchInput) {
    const client = algoliasearch('FONUCGK2F3', 'e533355e1a357dd4d4dd8b8803cc949e');
    const index = client.initIndex(appEnv + '_search_index');
    const searchResultsTable = document.getElementById('search-results-table');

    const searchTemplate = ' <tr class="bg-white">' +
        '<td class="px-6 py-4 text-sm leading-5 font-medium"><a href="[[PRODUCT_URL]]">[[TITLE]]</a></td>' +
        '<td class="px-6 py-4 text-right text-sm leading-5 font-medium">' +
        '<span class="inline-flex rounded-md shadow-sm"><a href="[[FILE_URL]]" class="inline-flex items-center px-6 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-50 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-blue-200 transition ease-in-out duration-150 antialiased font-bold">[[BUTTON]]</a></span>' +
        '</td>' +
        '</tr>';

    searchInput.addEventListener("keyup", function () {
        if (searchInput.value == '') {
            searchResultsTable.innerHTML = '';
        } else {
            index.search(searchInput.value, {
                hitsPerPage: 5
            }).then(({hits}) => {
                searchResultsTable.innerHTML = '';
                hits.forEach(function (hit) {
                    let hasAccess = false;
                    console.log(hit.accessId);
                    for (var i = 0; i <= hit.accessId.length; i++) {
                        let accessRef = hit.accessId[i];
                        if (userGroups.includes(accessRef)) {
                            hasAccess = true;
                        }
                    };
                    console.log(hasAccess);
                    if (hasAccess) {
                        if ((window.productId != 0 && window.productId == hit.productId) || window.productId === 0) {
                            let result = searchTemplate;
                            let resultHTML = result.replace('[[TITLE]]', hit.product + ' - ' + hit.title)
                                .replace('[[BUTTON]]', hit.button)
                                .replace('[[PRODUCT_URL]]', hit.url)
                                .replace('[[FILE_URL]]', hit.file_url);
                            searchResultsTable.innerHTML += resultHTML;
                        }
                    }
                });

            });
        }

    });
}


const passwordResetButton = document.getElementById('password-reset-trigger');
if (passwordResetButton) {
    const loginForm = document.getElementById('login-form');
    const resetForm = document.getElementById('login-reset-form');
    passwordResetButton.addEventListener("click", function (e) {
        e.preventDefault();
        loginForm.classList.add('hidden');
        resetForm.classList.remove('hidden');
        console.log('click');
    });
}




// WEBPACK FOOTER //
// ./src/js/main.js